module.exports = __webpack_public_path__ + "static/media/arrow_left_blue.37ee6123.svg";